import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import Signers from "../../../../pages/Profile/Documentation/Signers";
import { SignersContainerProps } from "../../../../interfaces/containers";
import { getRegions, getAllCities, getAllCommunes } from "../../../../actions/profile";
import { 
    getAllSigners, 
    postSigners, 
    cleanSigners, 
    putSigners, 
    patchBankData, 
    cleanBankData, 
    getValidSignersDocuments, 
    cleanValidSignersDocuments
} from "../../../../actions/documents";
import { getBanks, cleanBanks } from "../../../../actions/banks";
import { updateUser } from "../../../../actions/auth";

function mapStateToProps(state: SignersContainerProps) {
    return{
        user: state.auth.user,
        branch: state.profile.branch,
        signers: state.documents.signers,
        regions: state.profile.regions,
        cities: state.profile.cities,
        communes: state.profile.communes,
        banks: state.banks,
        valid: state.documents.valid.signers
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getAllSigners,
        getBanks,
        cleanBanks,
        patchBankData,
        cleanBankData,
        postSigners,
        putSigners,
        cleanSigners,
        getRegions,
        getAllCities,
        getAllCommunes,
        updateUser,
        getValidSignersDocuments, 
        cleanValidSignersDocuments
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Signers);